import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App.tsx';
import './index.css';
import { LanguageProvider } from './contexts/LanguageContext';

console.log('🟢 main.tsx loaded');

try {
  console.log('🟢 Creating root element');
  const rootElement = document.getElementById('root');
  console.log('🟢 Root element:', rootElement);

  if (!rootElement) {
    throw new Error('Root element not found');
  }

  console.log('🟢 Creating React root');
  const root = createRoot(rootElement);

  console.log('🟢 Rendering app');
  root.render(
    <StrictMode>
      <HelmetProvider>
        <LanguageProvider>
          <App />
        </LanguageProvider>
      </HelmetProvider>
    </StrictMode>
  );
  console.log('🟢 App rendered successfully');
} catch (error) {
  console.error('🔴 Error in main.tsx:', error);
  document.body.innerHTML = `
    <div style="padding: 20px; font-family: monospace;">
      <h1 style="color: red;">Error Loading App</h1>
      <pre>${error}</pre>
    </div>
  `;
}
